export const FUNC_NAMESPACE = "GEOLYSIS";

// FUNCTIONS
const AASHTO = "AASHTO";
const USCS = "USCS";
const UBC = "ULTIMATE_BEARING_CAPACITY";
const ABC = "ALLOWABLE_BEARING_CAPACITY";
const N_DESIGN = "SPT_N_DESIGN";
const ENERGY_CORR = "SPT_ENERGY_CORRECTION";
const OPC = "SPT_OVERBURDEN_PRESSURE_CORRECTION";
const DIL_CORR = "SPT_DILATANCY_CORRECTION";

// FUNCTION NAMESPACE
const AASHTO_NAMESPACE = `=${FUNC_NAMESPACE}.${AASHTO}`;
const USCS_NAMESPACE = `=${FUNC_NAMESPACE}.${USCS}`;
const UBC_NAMESPACE = `=${FUNC_NAMESPACE}.${UBC}`;
const ABC_NAMESPACE = `=${FUNC_NAMESPACE}.${ABC}`;
const N_DESIGN_NAMESPACE = `=${FUNC_NAMESPACE}.${N_DESIGN}`;
const ENERGY_CORR_NAMESPACE = `=${FUNC_NAMESPACE}.${ENERGY_CORR}`;
const OPC_NAMESPACE = `=${FUNC_NAMESPACE}.${OPC}`;
const DIL_CORR_NAMESPACE = `=${FUNC_NAMESPACE}.${DIL_CORR}`;

export const CUSTOM_FUNCTION_USAGE_EXAMPLES = {
  [AASHTO]: [`${AASHTO_NAMESPACE}(45, 16, 60)`, `${AASHTO_NAMESPACE}(45, 16, 60, TRUE)`],
  [USCS]: [
    `${USCS_NAMESPACE}(34.1, 21.1, 47.88, 37.84)`,
    `${USCS_NAMESPACE}(30.8, 20.7, 10.29, 81.89, 0.07, 0.3, 0.8)`,
  ],
  [UBC]: [
    `${UBC_NAMESPACE}(25.0, 20.0, 16.5, 1.5, 2.0,, 3,,,,,,"square", "terzaghi", FALSE)`,
    `${UBC_NAMESPACE}(25.0, 20.0, 16.5, 1.5, 2.0,, 3,,,,,,"square", "vesic", FALSE)`,
  ],
  [ABC]: [
    `${ABC_NAMESPACE}(12, 20.0, 1.5, 1.2,,,, "square", "pad", "bowles")`,
    `${ABC_NAMESPACE}(12, 20.0, 1.5, 1.2, , , , "square", "pad", "meyerhof")`,
  ],
  [N_DESIGN]: [`${N_DESIGN_NAMESPACE}(7.0, 15.0, 18.0)`, `${N_DESIGN_NAMESPACE}(7.0, 15.0, 18.0, 19.0, 22.0)`],
  [ENERGY_CORR]: [
    `${ENERGY_CORR_NAMESPACE}(30.0, 0.6, 65.0, 3.0, "donut_1", "standard")`,
    `${ENERGY_CORR_NAMESPACE}(30.0, 0.6, 120.0, 5.0, "automatic", "non_standard")`,
  ],
  [OPC]: [`${OPC_NAMESPACE}(22.5, 100.0, "gibbs")`, `${OPC_NAMESPACE}(22.5, 100.0, "bazaraa")`],
  [DIL_CORR]: [`${DIL_CORR_NAMESPACE}(22.5)`, `${DIL_CORR_NAMESPACE}(12.6)`],
};

// TODO: Remove equations
// export const CUSTOM_FUNCTION_EQNS = {
//   "SOIL_CLASSIFIER.AASHTO": "",
//   "SOIL_CLASSIFIER.USCS": "",
//   "BEARING_CAPACITY.ULTIMATE": {
//     "": `$$q_u = cN_c s_c d_c i_c + qN_q s_q d_q i_q + 0.5 \\gamma B N_{\\gamma} s_{\\gamma} d_{\\gamma} i_{\\gamma}$$`,
//   },
//   "BEARING_CAPACITY.ALLOWABLE": {
//     Bowles: `$$q_a(kPa) = 19.16(N_1)_{55} f_d\\left(\\dfrac{S}{25.4}\\right),\\ B \\ \\le \\ 1.2m $$

//       $$
//       q_a(kPa) = 11.98(N_1)_{55}\\left(\\dfrac{3.28B + 1}{3.28B} \\right)^2 f_d \\left(\\dfrac{S}{25.4}
//       \\right), \\ B \\ \\gt 1.2m
//       $$

//       $$f_d = 1 + 0.33 \\cdot \\frac{D_f}{B} \\le 1.33$$`,
//     Meyerhof: `$$q_a(kPa) = 12N f_d\\left(\\dfrac{S}{25.4}\\right), \\ B \\ \\le 1.2m $$

//     $$ q_a(kPa) = 8N\\left(\\dfrac{3.28B + 1}{3.28B} \\right)^2 f_d\\left(\\dfrac{S}{25.4}\\right),
//     \\ B \\ \\gt 1.2m$$

//     $$f_d = 1 + 0.33 \\cdot \\frac{D_f}{B} \\le 1.33$$`,
//     Terzaghi: `
//     $$q_a(kPa) = 12N \\dfrac{1}{c_w f_d}\\left(\\dfrac{S}{25.4}\\right),\\ \\ B \\ \\le 1.2m$$

//     $$q_a(kPa) = 8N\\left(\\dfrac{3.28B + 1}{3.28B} \\right)^2 \\dfrac{1}{c_w f_d}\\left(\\dfrac{S}{25.4}
//     \\right),\\ \\ B \\ \\gt 1.2m$$

//     $$f_d = 1 + 0.25 \\cdot \\frac{D_f}{B} \\le 1.25$$

//     $$c_w = 2 - \\frac{D_w}{2B} \\le 2,\\ D_w \\gt D_f$$

//     $$c_w = 2 - \\frac{D_f}{2B} \\le 2,\\ D_w \\le D_f$$`,
//   },
//   "SPT.N_DESIGN": {
//     "": `$$N_{design} = \\dfrac{\\sum_{i=1}^{n} \\frac{N_i}{i^2}}{\\sum_{i=1}^{n}
//   \\frac{1}{i^2}}$$`,
//   },
//   "SPT.ENERGY_CORRECTION": {
//     "": `$$N_{ENERGY} = \\dfrac{E_H \\cdot C_B \\cdot C_S \\cdot C_R \\cdot N}{ENERGY}$$`,
//   },
//   "SPT.OVERBURDEN_PRESSURE_CORRECTION": {
//     Gibbs: `
//     $$C_N = \\dfrac{350}{\\sigma_o + 70} \\, \\sigma_o \\le 280kN/m^2$$

//     $\\frac{N_c}{N_{60}}$ should lie between 0.45 and 2.0, if $\\frac{N_c}{N_{60}}$ is greater
//     than 2.0, $N_c$ should be divided by 2.0 to obtain the design value used in finding the
//     bearing capacity of the soil.
//     `,
//     Bazaraa: `
//       $$C_N = \\dfrac{4}{1 + 0.0418 \\cdot \\sigma_o},\\, \\sigma_o \\lt 71.8kN/m^2$$

//       $$C_N = \\dfrac{4}{3.25 + 0.0104 \\cdot \\sigma_o},\\, \\sigma_o \\gt 71.8kN/m^2$$

//       $$C_N = 1 \\, , \\, \\sigma_o = 71.8kN/m^2$$`,
//     Peck: `$$C_N = 0.77 \\log \\left(\\dfrac{2000}{\\sigma_o} \\right)$$`,
//     Liao: `$$C_N = \\sqrt{\\dfrac{100}{\\sigma_o}}$$`,
//     Skempton: `$$C_N = \\dfrac{2}{1 + 0.01044 \\cdot \\sigma_o}$$`,
//   },
//   "SPT.DILATANCY_CORRECTION": {
//     "": `
//   $$(N_1)_{60} = 15 + \\dfrac{1}{2}((N_1)_{60} - 15) \\, , \\, (N_1)_{60} > 15$$

//   $$(N_1)_{60} = (N_1)_{60} \\, , \\, (N_1)_{60} \\le 15$$`,
//   },
// };
